import { PaletteOptions } from '@mui/material'

export const createPalette = (isDark: boolean): PaletteOptions => ({
  background: {
    //default: isDark ? '#212A34' : '#fff',
    default: isDark ? '#131A20' : '#fff',
    paper: isDark ? '#1C2731' : '#F5F5F8',
    blue: isDark ? '#24303F' : '#F8FAFF',
    green: '#33E771',
    greenHover: '#0AE15F',
    footer: isDark ? '#10171D' : '#24303B',
    error: '#F92B44',
  },
  icons: {
    main: isDark ? '#F0F6F9' : '#212A34',
    secondary: isDark ? '#9DAAB4' : '#6B7782',
    onControls: isDark ? '#F0F6F9' : '#FAFBFC',
    green: '#33E771',
    yellow: isDark ? '#D9902B' : '#F2A130',
  },
  divider: isDark ? '#3C4B59' : '#F0F1F3',
  lines: {
    dividing: '',
    grey: isDark ? '#252F38' : '#F5F5F8',
    green: '#33E771',
    red: isDark ? '#A44848' : '#E97070',
  },
  primary: {
    main: isDark ? '#0F9949' : '#12B857',
  },
  secondary: {
    main: isDark ? '#212A34' : '#F5F5F8',
    dark: '#F1F1F5',
  },
  white: {
    main: '#FFFFFF',
    dark: '#FAFAFA',
    contrastText: '#212A34',
  },
  infomer: {
    warning: {
      bg: isDark ? '#362F27' : '#FEF6EA',
      text: isDark ? '#F0F6F9' : '#212A34',
    },
  },
  subtitle: {
    primary: isDark ? 'rgba(240,246,249,0.25)' : 'rgba(245,245,248,0.25)',
  },
  linkPage: {
    active: isDark ? '#0F9949' : '#12B857',
    notActive: 'rgba(0,0,0,0)',
  },
  linkPageText: {
    active: isDark ? '#F0F6F9' : '#F5F5F8',
    notActive: isDark ? 'rgba(240,246,249,0.5)' : 'rgba(245,245,248,0.5)',
  },
  text: {
    primary: isDark ? '#F0F6F9' : '#212A34',
    secondary: isDark ? '#9DAAB4' : '#6B7782',
    tertiary: isDark ? '#4E5D6A' : '#9798A0',
    link: isDark ? '#01923A' : '#01A642',
    onControls: isDark ? '#F0F6F9' : '#FAFBFC',
    onControlsDark: '#212A34',
    disabled: isDark ? '#5F676D' : '#B2B7BA',
  },
  error: {
    main: isDark ? '#A44848' : '#E97070',
  },
  chip: {
    info: {
      bg: isDark ? '#232E38' : '#EDEEEF',
      text: isDark ? '#9DAAB4' : '#6B7782',
    },
    warning: {
      bg: isDark ? '#1A3546' : '#E8F3F9',
      text: isDark ? '#349AD4' : '#4098C9',
    },
    success: {
      bg: isDark ? '#0F3C29' : '#E1F4E8',
      text: isDark ? '#00AC44' : '#01A642',
    },
    error: {
      bg: isDark ? '#422B30' : '#FCEEEE',
      text: isDark ? '#F65757' : '#E97070',
    },
  },
})
